import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environments';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getScore(token: string): Observable<any> {
    const header = {
      'X-App-Auth': token,
    };
    return this.http.get(`${baseUrl}points`, { headers: header });
  }
}
